<template>
  <div id="UpdateInvoice" class="user-page">
    <h3 class="mb-4">{{$t('profile.invoice_info')}} </h3>
    <div uk-grid>
      <div class="uk-width-expand@m">
        <div class="uk-card-default rounded">
          <div class="p-3">
            <h5 class="m-0">{{$t('profile.update_invoice_info')}}</h5>
            <div v-if="successMessage" class="uk-alert-success" uk-alert>
              <a class="uk-alert-close" uk-close></a>
              <p style="color:green;">
                <i class="uil-exclamation-triangle"></i> {{ successMessage }}
              </p>
            </div>
            <div v-if="errors" class="uk-alert-danger" uk-alert>
              <a class="uk-alert-close" uk-close></a>
              <p style="color:red;">
                <i class="uil-exclamation-triangle"></i> {{ errors }}
              </p>
            </div>
            <div v-for="error in errorMessages" v-if="errorMessages" class="uk-alert-danger" uk-alert>
              <a class="uk-alert-close" uk-close></a>
              <p style="color:red;">
                <i class="uil-exclamation-triangle"></i> {{ error }}
              </p>
            </div>
          </div>
          <hr class="m-0">
          <form @submit.prevent="onSubmit()">
            <div class="uk-child-width-1-1@s uk-grid-small p-4 pb-0" uk-grid>
              <h5 class="uk-text-bold mb-2"> {{$t('profile.invoice_type')}} </h5>
              <div class="uk-form-controls uk-form-controls-text d-flex">
                <label class="mr-4">
                  <input class="uk-radio" type="radio" name="radio" 
                    :checked="selectedType === 'institutional'"
                    @change="setType('institutional')"> {{$t('profile.corporate')}}
                </label>
                <label>
                  <input class="uk-radio" type="radio" name="radio" 
                    :checked="selectedType === 'individual'"
                    @change="setType('individual')"> {{$t('profile.individual')}}
                </label>
              </div>
            </div>

            <!--Kurumsal Fatura Formu-->
            <template v-if="selectedType === 'institutional'">

              <div class="uk-child-width-1-2@s uk-grid-small p-4" uk-grid>
                <div>
                  <h5 class="uk-text-bold mb-2"> {{$t('general.business_partner_name')}}*</h5>
                  <input v-model="company_name" class="uk-input" type="text">
                </div>
                <div>
                  <h5 class="uk-text-bold mb-2"> {{$t('general.tax_office')}}*</h5>
                  <input v-model="tax_office" class="uk-input" type="text">
                </div>
                <div>
                  <h5 class="uk-text-bold mb-2"> {{$t('profile.tax_number')}}*</h5>
                  <input v-model="tax_number" class="uk-input" type="text">
                </div>
                <div>
                  <h5 class="uk-text-bold mb-2"> {{$t('general.country')}}*</h5>
                  <input v-model="country" class="uk-input" type="text">

                  <!-- <select>
                    <option value="">Ülke Seçiniz</option>
                    <option value="1">Türkiye</option>
                  </select> -->
                </div>
                <div>
                  <h5 class="uk-text-bold mb-2"> {{$t('general.city')}}*</h5>
                  <input v-model="state" class="uk-input" type="text">

                  <!-- <select>
                    <option value="">Şehir Seçiniz</option>
                    <option value="1">Türkiye</option>
                  </select> -->
                </div>
                <div>
                  <h5 class="uk-text-bold mb-2"> {{$t('general.district')}}*</h5>
                  <input v-model="city" class="uk-input" type="text">

                </div>
              </div>
              <div class="uk-child-width-1-1@s uk-grid-small p-4 pt-0" uk-grid>
                <div>
                  <h5 class="uk-text-bold mb-2"> {{$t('profile.address')}}*</h5>
                  <textarea name="" v-model="address" id="" class="uk-textarea"></textarea>
                </div>
              </div>
            </template>

            <hr>

            <!--Bireysel Fatura Formu-->
            <template v-if="selectedType === 'individual'">
              <div class="uk-child-width-1-2@s uk-grid-small p-4" uk-grid>
                <div>
                  <h5 class="uk-text-bold mb-2"> {{$t('general.first_name_and_last_name')}}*</h5>
                  <input class="uk-input" v-model="first_name_last_name" type="text">
                </div>
                <div>
                  <h5 class="uk-text-bold mb-2"> {{$t('general.national_label')}}*</h5>
                  <input class="uk-input" v-model="tc" type="text">
                </div>
                <div>
                  <h5 class="uk-text-bold mb-2"> {{$t('general.country')}}*</h5>
                  <input v-model="country" class="uk-input" type="text">
                  <!-- <select>
                    <option value="">Ülke Seçiniz</option>
                    <option value="1">Türkiye</option>
                  </select> -->
                </div>
                <div>
                  <h5 class="uk-text-bold mb-2"> {{$t('general.city')}}*</h5>
                  <input v-model="state" class="uk-input" type="text">
                  <!-- <select>
                    <option value="">Şehir Seçiniz</option>
                    <option value="1">Türkiye</option>
                  </select> -->
                </div>
                <div>
                  <h5 class="uk-text-bold mb-2"> {{$t('general.district')}}*</h5>
                  <!-- <input class="uk-input" type="text"> -->
                  <input v-model="city" class="uk-input" type="text">

                </div>
              </div>
              <div class="uk-child-width-1-1@s uk-grid-small p-4 pt-0" uk-grid>
                <div>
                  <h5 class="uk-text-bold mb-2"> Adres*</h5>
                  <textarea name="" id="" v-model="address" class="uk-textarea"></textarea>
                </div>
              </div>
            </template>

          </form>
          <div class="uk-flex uk-flex-right p-4">
            <button class="btn btn-link mr-2" @click="$router.go(-1)">{{ $t('general.cancel') }}</button>
            <button class="btn btn-default grey" @click="onSubmit()">{{ $t('general.save') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>



  <!-- <div id="UpdateProfile" class="page-content-inner">
    <h3 class="mb-4">{{ $t('profile.account_settings') }}</h3>
    <div uk-grid>
      <div class="uk-width-1-4@m uk-flex-last@m">
        <div class="uk-card-default rounded text-center p-4">
          <div class="uk-position-relative my-4">
            <div class="user-profile-photo  m-auto">
              <img id="profile-image-holder" :src="profileUser.photo_link" alt="">
            </div>
            <div class="uk-position-center">
              <div uk-form-custom>
                <input ref="file" type="file" accept="image" @change="onChangeFile">
                <span class="uk-link icon-feather-camera icon-medium text-white"> </span>
              </div>
            </div>
          </div>
          <button class="btn btn-default m-auto mb-3" @click="updateProfilePhoto"><i class="uil-image-upload"></i>
            {{ $t('profile.update_photo') }}
          </button>
        </div>
      </div>
      <div class="uk-width-expand@m">
        <div class="uk-card-default rounded">
          <div class="p-3">
            <h5 class="mb-0"> {{ $t('profile.update_personal_information') }} </h5>
            <div v-if="successMessage" class="uk-alert-success" uk-alert>
              <a class="uk-alert-close" uk-close></a>
              <p style="color:green;">
                <i class="uil-exclamation-triangle"></i> {{ successMessage }}
              </p>
            </div>
            <div v-if="errors" class="uk-alert-danger" uk-alert>
              <a class="uk-alert-close" uk-close></a>
              <p style="color:red;">
                <i class="uil-exclamation-triangle"></i> {{ errors }}
              </p>
            </div>
            <div v-for="error in errorMessages" v-if="errorMessages" class="uk-alert-danger" uk-alert>
              <a class="uk-alert-close" uk-close></a>
              <p style="color:red;">
                <i class="uil-exclamation-triangle"></i> {{ error }}
              </p>
            </div>
          </div>
          <hr class="m-0">
          <form @submit.prevent="onSubmit()">
            <div class="uk-child-width-1-2@s uk-grid-small p-4" uk-grid>
              <div>
                <h5 class="uk-text-bold mb-2"> {{ $t('profile.name') }} </h5>
                <input v-model="profileUser.name" class="uk-input" type="text">
              </div>
              <div>
                <h5 class="uk-text-bold mb-2"> {{ $t('profile.surname') }} </h5>
                <input v-model="profileUser.surname" class="uk-input" type="text">
              </div>
              <div>
                <h5 class="uk-text-bold mb-2"> {{ $t('profile.dob') }} </h5>
                <input v-model="profileUser.dob" :formatter="format" class="uk-input" type="date">
              </div>
              <div>
                <h5 class="uk-text-bold mb-2"> {{ $t('profile.email') }} </h5>
                <input v-model="profileUser.email" class="uk-input" disabled type="text">
              </div>
              <div>
                <h5 class="uk-text-bold mb-2"> {{ $t('profile.phone') }} </h5>
                <vue-tel-input v-model="maskPhone" :inputOptions="options" type="text"></vue-tel-input>
              </div>
            </div>
            <hr>
            <div class="uk-child-width-1-2@s uk-grid-small p-4" uk-grid>
              <div>
                <h5 class="uk-text-bold mb-2"> {{ $t('profile.login_password') }} </h5>
                <input v-model="password" class="uk-input mb-1" type="password" autocomplete="chrome-off">
                <ol class="bg-white W-100 pt-1 pl-2 mb-1">
                  <li v-if="passwordValidation.hasUpperLetter" class="uk-text-small m-0" style="color:grey;">
                    <i aria-hidden="true" class="fa fa-check d-inline-flex mr-1"></i>{{
                      $t('errors.password_must_have_upper_latter') }}
                  </li>
                  <li v-if="passwordValidation.hasLowerLetter" class="uk-text-small m-0" style="color:grey;">
                    <i aria-hidden="true" class="fa fa-check d-inline-flex mr-1"></i>{{
                      $t('errors.password_must_have_lower_latter') }}
                  </li>
                  <li v-if="passwordValidation.hasNumber" class="uk-text-small m-0" style="color:grey;">
                    <i aria-hidden="true" class="fa fa-check d-inline-flex mr-1"></i>{{
                      $t('errors.password_must_have_number') }}
                  </li>
                  <li v-if="passwordValidation.hasAtLeast8Letters" class="uk-text-small m-0" style="color:grey;">
                    <i aria-hidden="true" class="fa fa-check d-inline-flex mr-1"></i>{{
                      $t('errors.password_must_more_than_7') }}
                  </li>
                  <li v-if="!passwordValidation.hasUpperLetter" class="uk-text-small m-0" style="color:red;">
                    <i class="fa fa-dot-circle mr-1" style="font-size:9px"></i>{{
                      $t('errors.password_must_have_upper_latter') }}
                  </li>
                  <li v-if="!passwordValidation.hasLowerLetter" class="uk-text-small m-0" style="color:red;">
                    <i class="fa fa-dot-circle mr-1" style="font-size:9px"></i>{{
                      $t('errors.password_must_have_lower_latter') }}
                  </li>
                  <li v-if="!passwordValidation.hasNumber" class="uk-text-small m-0" style="color:red;">
                    <i class="fa fa-dot-circle mr-1" style="font-size:9px"></i>{{ $t('errors.password_must_have_number')
                    }}
                  </li>
                  <li v-if="!passwordValidation.hasAtLeast8Letters" class="uk-text-small m-0" style="color:red;">
                    <i class="fa fa-dot-circle mr-1" style="font-size:9px"></i>{{ $t('errors.password_must_more_than_7')
                    }}
                  </li>
                </ol>
              </div>
              <div>
                <h5 class="uk-text-bold mb-2"> {{ $t('profile.login_password_confirm') }} </h5>
                <input v-model="password_confirmation" class="uk-input" type="password">
              </div>
              <div v-if="company.is_allowed_login_type">
                <h5 class="uk-text-bold mb-2">{{ $t('profile.login_type') }}</h5>
                <select name="login_type" v-model="profileUser.login_type_id">
                  <option v-for="item in login_types" :value="item.id">{{ item.name }}</option>
                </select>
              </div>
              <div v-if="company.is_allowed_authentication_type">
                <h5 class="uk-text-bold mb-2">{{ $t('profile.authentication_type') }}</h5>
                <select name="authentication_type" v-model="profileUser.authentication_type_id">
                  <option v-for="item in authentication_types" :value="item.id" :key="item.id">{{
                    $t('general.'+item.name) }}
                  </option>
                </select>
              </div>
            </div>
          </form>
          <div class="uk-flex uk-flex-right p-4">
            <button class="btn btn-link mr-2" @click="$router.go(-1)">{{ $t('general.cancel') }}</button>
            <button class="btn btn-default grey" @click="onSubmit()">{{ $t('general.save') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import module, {
  CURRENT_ITEM,
  ERROR,
  GET_USER,
  SET_ERROR,
  UPDATE_USER,
  UPDATE_USER_PHOTO,
  MODULE_NAME
} from "@/core/services/store/user.module";
import moment from "moment";
import store from "@/core/services";
import { TheMask } from 'vue-the-mask';
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import $ from 'jquery';
import SecureLS from "secure-ls";
import axios from "axios";

const ls = new SecureLS({ encodingType: 'aes', isCompression: true });

export default {
  name: "UpdateInvoice",
  components: {
    TheMask,
    VueTelInput,
  },
  data() {
    return {
      entity_type: "corporate",
      company_name: "",
      tax_office: "",
      tax_number: "",
      country: "",
      state: "",
      city: "",
      address: "",
      first_name_last_name: "",
      tc: "",
      selectedType: 'institutional',
      maskPhone: '',
      apiURL: 'api/user/',
      successMessage: '',
      password: null,
      password_confirmation: null,
      user_photo: null,
      profileImage: null,
      errorMessages: [],
      errorMessage: null,
      company: {},
      options: {
        showDialCode: true,
        placeholder: '5XXXXXXXXX',
        styleClasses: ['uk-input', 'border-0', 'w-100', 'h-0', 'form-input', 'uk-form-input', 'p-0', 'm-0']
      },
      login_types: [],
      authentication_types: [],
    };
  },
  computed: {
    errors: {
      get() {
        return store.getters[MODULE_NAME + '/' + ERROR]
      },
      set(value) {
      }
    },
    profileUser: {
      get() {
        let user = store.getters[MODULE_NAME + '/' + CURRENT_ITEM]
        user.dob = user.dob ? moment(user.dob).format('YYYY-MM-DD') : null
        if (user.phone && user.phone.length === 10) {
          user.phone = "0" + user.phone;
        }

        return user
      },
      set(value) {
      }
    }
  },
  methods: {
    setType(type) {
      this.selectedType = type;
      if (type === 'institutional') {
        this.entity_type = 'corporate'
      } else if (type === 'individual') {
        this.entity_type = 'individual'
      }
    },
    getAuthenticationTypes() {
      let types = []
      axios.get(`api/user/authentication-types`, {
        headers: this.apiHeaders
      }).then((result) => {
        result.data.forEach(data => {
          types.push({
            id: data.id,
            name: this.$t(data.key_name)
          })
        });
      })
      this.authentication_types = types
    },
    getLoginTypes() {
      let types = []
      axios.get(`api/user/login-types`, {
        headers: this.apiHeaders
      }).then((result) => {
        result.data.forEach(data => {
          types.push({
            id: data.id,
            name: this.$t('general.' + data.key_name)
          })
        });
      })
      this.login_types = types
    },
    getCompany() {
      let self = this;
      axios.get(`api/company/self`, {
        headers: this.apiHeaders
      }).then((result) => {
        self.company = result.data
      })
    },
    onChangeFile() {
      let value = this.$refs.file.files[0];
      this.profileImage = value;
      let blob = URL.createObjectURL(value);
      let imageHolder = $('#profile-image-holder');
      imageHolder.attr('src', blob);
    },
    format(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    createUserData(entityType) {
      this.maskPhone = this.maskPhone.substring(this.maskPhone.indexOf(' ') + 1).replaceAll(' ', '');
      let userData = {
        name: this.profileUser.name,
        surname: this.profileUser.surname,
        dob: this.profileUser.dob,
        phone: this.maskPhone,
        login_type_id: this.profileUser.login_type_id,
        authentication_type_id: this.profileUser.authentication_type_id,
        country_phone_code: this.maskPhone.substring(0, this.maskPhone.indexOf(' ')).substring(1),
        vat_info: {
          entity_type: entityType
        }
      };

      if (entityType === "individual") {
        userData.vat_info.individual = {
          first_name_last_name: this.first_name_last_name,
          tc: this.tc,
          country: this.country,
          state: this.state,
          city: this.city,
          address: this.address
        };
      } else if (entityType === "corporate") {
        userData.vat_info.corporate = {
          company_name: this.company_name,
          tax_office: this.tax_office,
          tax_number: this.tax_number,
          country: this.country,
          state: this.state,
          city: this.city,
          address: this.address
        };
      }
      return userData;
    },
    onSubmit() {
      this.$store.commit(MODULE_NAME + '/' + SET_ERROR, null)
      let country_phone_code = this.maskPhone.substring(0, this.maskPhone.indexOf(' ')).substring(1)
      this.maskPhone = this.maskPhone.substring(this.maskPhone.indexOf(' ') + 1).replaceAll(' ', '');
      // phoneNumber = phoneNumber.replace(/ /g, '').substring(1);
      let form = this.createUserData(this.entity_type);
      this.errorMessages = [];
      this.successMessage = null;

      if (this.profileUser.name.length === 0) {
        this.errorMessages.push(
          this.$t('errors.user_name_required'),
        );
        return false
      }
      if (this.profileUser.surname.length === 0) {
        this.errorMessages.push(
          this.$t('errors.user_surname_required'),
        );
        return false
      }
      if (this.profileUser.email.length === 0) {
        this.errorMessages.push(
          this.$t('errors.user_email_required'),
        );
        return false
      }
      this.$store.dispatch(MODULE_NAME + '/' + UPDATE_USER, {
        url: this.apiURL + this.profileUser.id,
        contents: form,
      }).then(() => {
        setTimeout(() => {
          if (!this.errors) {
            this.successMessage = this.$t('profile.your_information_updated')
          }
        }, 500)
      })
    },
    updateProfilePhoto() {
      this.$store.commit(MODULE_NAME + '/' + SET_ERROR, null)
      let form = new FormData();
      form.append('photo', this.profileImage);
      this.$store.dispatch(MODULE_NAME + '/' + UPDATE_USER_PHOTO, {
        url: this.apiURL + this.profileUser.id + '/photo',
        contents: form,
      }).then((response) => {
        if (!this.errors) {
          this.successMessage = this.$t('profile.your_information_updated')
          let user_data = this.authUser
          if (this.profileImage) {
            user_data.photo = this.profileUser.photo_link
          }
          window.localStorage.removeItem('user');
          let tempUser = {};
          Object.assign(tempUser, user_data);
          ls.set('user', JSON.stringify(tempUser));
          location.reload()
        }
      })
    }
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule)
      }
    }

    registerStoreModule(MODULE_NAME, module)
  },
  mounted() {
    this.$store.dispatch(MODULE_NAME + '/' + GET_USER, {
      url: this.apiURL + 'self',
      acceptPromise: true,
    }).then((response) => {
      const user = response.data;
      // this.getAuthenticationTypes()
      // this.getLoginTypes()
      // this.getCompany()

      if (user.vat_info) {
        // fatura tipini oto bul
        this.entity_type = user.vat_info.entity_type;
        this.selectedType = user.vat_info.entity_type === 'corporate' ? 'institutional' : 'individual';
        if (user.vat_info.entity_type === 'corporate') {
          this.company_name = user.vat_info.corporate.company_name || '';
          this.tax_office = user.vat_info.corporate.tax_office || '';
          this.tax_number = user.vat_info.corporate.tax_number || '';
          this.country = user.vat_info.corporate.country || '';
          this.state = user.vat_info.corporate.state || '';
          this.city = user.vat_info.corporate.city || '';
          this.address = user.vat_info.corporate.address || '';
        } else if (user.vat_info.entity_type === 'individual') {
          this.first_name_last_name = user.vat_info.individual.first_name_last_name || '';
          this.tc = user.vat_info.individual.tc || '';
          this.country = user.vat_info.individual.country || '';
          this.state = user.vat_info.individual.state || '';
          this.city = user.vat_info.individual.city || '';
          this.address = user.vat_info.individual.address || '';
        }
      }
    });
  },
}
</script>

<style scoped></style>
